import type { LucideIcon } from "lucide-react";
import {
  Bell,
  Briefcase,
  Building2,
  CalendarCheck,
  CalendarClock,
  CalendarX,
  Factory,
  Handshake,
  Info,
  PencilLine,
  RotateCcw,
  Scan,
  ShieldCheck,
  Stethoscope,
  UserPlus, Trash2, Download, AlertTriangle } from "lucide-react";

/** Mapeia nome de ícone (string persistida no DB) → componente lucide.
 *  Se o nome não existe, usa Bell como fallback. */
const ICON_MAP: Record<string, LucideIcon> = {
  Bell,
  Trash2,
  Download,
  AlertTriangle,
  Briefcase,
  Building2,
  CalendarCheck,
  CalendarClock,
  CalendarX,
  Factory,
  Handshake,
  Info,
  PencilLine,
  RotateCcw,
  Scan,
  ShieldCheck,
  Stethoscope,
  UserPlus,
};

export function iconFor(name: string | null | undefined): LucideIcon {
  if (!name) return Bell;
  return ICON_MAP[name] ?? Bell;
}
